<template>
    <div v-html="partial.data.html"></div>
</template>


<script>
import autoValidate from './autoValidateMixin'
import autoGlossary from 'js/components/elements/autoGlossaryMixin'

export default {
    mixins: [
        autoValidate,
        autoGlossary,
    ],

    methods: {
        flush: function() {
            return Promise.resolve()
        },
    }
}
</script>


<style lang="scss">

    @import 'global';

    .example {
        padding-left: 1em;
        padding-right: 1em;

        font-style: italic;
    }

</style>



// WEBPACK FOOTER //
// HtmlPartial.vue?7d522fe8